import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-color-um-blue mt-0 mb-0" }
const _hoisted_2 = { class: "text-color-um-blue" }
const _hoisted_3 = { class: "flex align-items-center mt-4" }
const _hoisted_4 = { class: "p-button-label" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-right p-button-icon" }, null, -1)
const _hoisted_6 = {
  class: "text-color-um-blue mx-4",
  style: {"font-size":"22px"}
}
const _hoisted_7 = { class: "p-button-label" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-globe" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-right p-button-icon" }, null, -1)
const _hoisted_10 = { class: "text-center mb-3" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { style: {"font-size":"20px"} }
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  id: "info_circles",
  class: "grid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IntroBanner = _resolveComponent("IntroBanner")!
  const _component_InfoRow = _resolveComponent("InfoRow")!
  const _component_Title = _resolveComponent("Title")!
  const _component_InfoCircle = _resolveComponent("InfoCircle")!
  const _component_Section = _resolveComponent("Section")!
  const _component_Register = _resolveComponent("Register")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_IntroBanner, {
      title: _ctx.state.banner.title,
      "background-image": _ctx.state.banner.image
    }, {
      footer: _withCtx(() => [
        _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.t("content.globalSearchTitle")), 1),
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.t("content.globalSearchSubTitle")), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "router-link",
            to: "/research/equipment"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                type: "button",
                class: "p-button-iconEdge",
                style: {"width":"300px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("content.globalSearchKeyworkInputPlaceholder")), 1)
                  ]),
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("strong", _hoisted_6, _toDisplayString(_ctx.t("content.globalSearchAlternativeOperator")), 1),
          _createVNode(_component_router_link, {
            class: "router-link",
            to: "/map"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                type: "button",
                class: "p-button-iconEdge",
                style: {"width":"300px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("span", null, _toDisplayString(_ctx.t("content.globalSearchOpenMapButton")), 1)
                  ]),
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["title", "background-image"]),
    (_ctx.isAuthenticated === false)
      ? (_openBlock(), _createBlock(_component_InfoRow, { key: 0 }, {
          left: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: require('@/assets/images/info-row-icon.svg'),
                  alt: "",
                  style: {"width":"140px"}
                }, null, 8, _hoisted_11)
              ]),
              _createVNode(_component_Button, {
                style: {"width":"300px"},
                type: "button",
                class: "p-button-iconEdge minWidth mt-3",
                icon: "icon-chevron-right",
                "icon-pos": "right",
                label: _ctx.t('content.createAccountButton'),
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.state.dialog.register = true), ["prevent"]))
              }, null, 8, ["label"])
            ]),
            _createVNode(_component_Button, {
              style: {"width":"300px"},
              type: "button",
              class: "p-button-iconEdge minWidth mt-3",
              icon: "icon-chevron-right",
              "icon-pos": "right",
              label: _ctx.t('content.loginUMButton'),
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onClickLogin()), ["prevent"]))
            }, null, 8, ["label"])
          ]),
          right: _withCtx(() => [
            _createElementVNode("h3", null, _toDisplayString(_ctx.t("content.createAccountTitle")), 1),
            _createElementVNode("p", _hoisted_12, [
              _createTextVNode(_toDisplayString(_ctx.t("content.createAccountDescription")) + " ", 1),
              _createElementVNode("a", {
                class: "link text-color-white",
                href: `mailto:${_ctx.contact.email}`
              }, _toDisplayString(_ctx.contact.email), 9, _hoisted_13)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Section, null, {
      default: _withCtx(() => [
        _createVNode(_component_Title, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("content.globalOverviewTitle")), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.infoCircles, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col"
            }, [
              _createVNode(_component_InfoCircle, {
                title: item.title,
                entity: item.entity,
                number: item.number
              }, null, 8, ["title", "entity", "number"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Register, {
      show: _ctx.state.dialog.register,
      "close-on-escape": true,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.dialog.register = false))
    }, null, 8, ["show"])
  ], 64))
}